function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4167",
  "data-name": "Group 4167",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_1",
  "data-name": "Subtraction 1",
  d: "M33.631,49.575H0l6.257-3.092.129-.213H31.979V3.3h-23V0H40.933c5.126,0,9.3,3.707,9.3,8.262v33.05c0,4.556-4.17,8.262-9.3,8.262h-7.3ZM35.284,3.3V46.27h5.649c3.075,0,5.577-2.224,5.577-4.957V8.262c0-2.734-2.5-4.958-5.577-4.958Zm6.683,26.44a1.654,1.654,0,0,1-1.653-1.652v-6.61a1.652,1.652,0,1,1,3.3,0v6.61A1.654,1.654,0,0,1,41.966,29.745Z",
  transform: "translate(39.011 39.66)",
  fill: "#656565"
}), /*#__PURE__*/React.createElement("g", {
  id: "smartphone",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4157",
  "data-name": "Group 4157",
  transform: "translate(0 14.944)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4156",
  "data-name": "Group 4156"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4974",
  "data-name": "Path 4974",
  d: "M143.922,85.333H97.653a1.653,1.653,0,0,0,0,3.305h46.27a1.653,1.653,0,1,0,0-3.305Z",
  transform: "translate(-96 -85.333)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4159",
  "data-name": "Group 4159",
  transform: "translate(21.483 76.015)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4158",
  "data-name": "Group 4158"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4975",
  "data-name": "Path 4975",
  d: "M237.972,426.667a3.3,3.3,0,1,0,3.3,3.3A3.31,3.31,0,0,0,237.972,426.667Z",
  transform: "translate(-234.667 -426.667)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4161",
  "data-name": "Group 4161",
  transform: "translate(19.83 6.61)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4160",
  "data-name": "Group 4160"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4976",
  "data-name": "Path 4976",
  d: "M232.262,42.667h-6.61a1.652,1.652,0,1,0,0,3.3h6.61a1.652,1.652,0,0,0,0-3.3Z",
  transform: "translate(-223.999 -42.667)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4163",
  "data-name": "Group 4163"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4162",
  "data-name": "Group 4162"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4977",
  "data-name": "Path 4977",
  d: "M137.313,0h-33.05C99.708,0,96,4.172,96,9.3V79.94c0,5.124,3.708,9.3,8.262,9.3h33.05c4.554,0,8.263-4.172,8.263-9.3V9.3C145.575,4.172,141.867,0,137.313,0Zm4.958,79.94c0,3.075-2.224,5.577-4.958,5.577h-33.05c-2.733,0-4.958-2.5-4.958-5.577V9.3c0-3.075,2.224-5.577,4.958-5.577h33.05c2.733,0,4.958,2.5,4.958,5.577V79.94Z",
  transform: "translate(-96)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4165",
  "data-name": "Group 4165",
  transform: "translate(0 67.25)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4164",
  "data-name": "Group 4164"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4978",
  "data-name": "Path 4978",
  d: "M143.922,384H97.653a1.653,1.653,0,0,0,0,3.305h46.27a1.653,1.653,0,1,0,0-3.305Z",
  transform: "translate(-96 -384)",
  fill: "#fff"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Path_4980",
  "data-name": "Path 4980",
  d: "M254.728,71.692l4.029,4.028a1.6,1.6,0,0,0,2.262,0l4.029-4.028a1.6,1.6,0,0,0-1.132-2.731h-2.888a27.635,27.635,0,0,0-26.513-26.526V39.546a1.6,1.6,0,0,0-2.731-1.132l-4.028,4.029a1.6,1.6,0,0,0,0,2.263l4.028,4.027a1.6,1.6,0,0,0,2.731-1.131V44.761a25.309,25.309,0,0,1,24.187,24.2h-2.842a1.6,1.6,0,0,0-1.132,2.731ZM232.19,45.854l-2.28-2.28,2.28-2.28Zm29.977,25.431-2.28,2.28-2.28-2.28Zm0,0",
  transform: "translate(-176.277 -37.945)",
  fill: "#9f9f9f"
}), /*#__PURE__*/React.createElement("g", {
  id: "check-mark",
  transform: "translate(13.478 33.308)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4166",
  "data-name": "Group 4166"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4981",
  "data-name": "Path 4981",
  d: "M11.309,0A11.309,11.309,0,1,0,22.619,11.309,11.322,11.322,0,0,0,11.309,0Zm6.459,8.068L9.62,16.217a.942.942,0,0,1-1.333,0L3.908,11.838a.471.471,0,0,1,0-.666l.666-.666a.471.471,0,0,1,.666,0l3.713,3.713,7.482-7.482a.471.471,0,0,1,.666,0l.666.666A.471.471,0,0,1,17.768,8.068Z",
  fill: "#f6c244"
}))));

var SvgRotatePhone = function SvgRotatePhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.24,
    height: 89.235,
    viewBox: "0 0 89.24 89.235",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRotatePhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RotatePhone.e9722f44.svg";
export { ForwardRef as ReactComponent };